module.exports = __webpack_public_path__ + "img/user11.b7eff36a.jpg";